import { render } from "./UserInfoSectionMenuCmp.vue?vue&type=template&id=ba4a3fe4&scoped=true"
import script from "./UserInfoSectionMenuCmp.vue?vue&type=script&lang=js"
export * from "./UserInfoSectionMenuCmp.vue?vue&type=script&lang=js"

import "../css/UserInfoSection.css?vue&type=style&index=0&id=ba4a3fe4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4a3fe4"]])

export default __exports__